import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useEffect, useState } from "react";

const TopBarWrapper = styled.div`
  position: fixed;
  top: 0;
  height: 85px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  -webkit-box-shadow: 1px 0px 16px -6px #000000;
  box-shadow: 1px 0px 16px -6px #000000;
  z-index: 10;
  background: var(--accent-color-dark);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);

  h2 {
    z-index: 10;
    padding-right: 20px;
    font-weight: 400;
    font-size: 20px;
    text-transform: capitalize;
    color: white;
    user-select: none;
  }
`;

const LogoWrapper = styled.div`
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;

  h2 {
    z-index: 10;
    font-size: 13px;
    margin-left: 4px;
    color: #ffffff;
    user-select: none;
  }
`;

const Logo = styled.img`
  z-index: 10;
  height: 60px;
  width: 60px;
`;

function TopBar(props: Props) {
  const [pageName, setPageName] = useState<string>("");
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/", 2);
    const pageName = path[path.length - 1];
    setPageName(pageName);
  }, [location]);

  return (
    <TopBarWrapper>
      <LogoWrapper>
        <Logo
          src="https://ik.imagekit.io/zfxtfuuid/Hillsong%20Pastoral%20Care%20App/tr:w-200/Hillsong_Circle_Outline_white.png?updatedAt=1690870900901"
          alt="Hillsong Logo"
        />
        <h2>
          Pastoral
          <br />
          Care
        </h2>
      </LogoWrapper>
      <h2></h2>
    </TopBarWrapper>
  );
}

interface Props {}

export default TopBar;
